var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var YusdToken = function (_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? "black" : _b, _c = _a.color, color = _c === void 0 ? "white" : _c, _d = _a.width, width = _d === void 0 ? 24 : _d, _e = _a.height, height = _e === void 0 ? 24 : _e, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", fill: backgroundColor }),
            React.createElement("path", { d: "M12.0005 13.25H8.875V16.3745L12.0005 13.25Z", fill: color }),
            React.createElement("path", { d: "M12.0001 10.1245L15.1247 7H12.0001L8.87457 10.1245L5.75 13.2499H8.87457L12.0001 10.1245Z", fill: color }),
            React.createElement("path", { d: "M15.1256 10.1245L12.001 13.2499H15.1256L18.2501 10.1245H15.1256Z", fill: color }))));
};
var templateObject_1;
